import { createSelector } from 'reselect';
const userStateSelector = (state) => state.user;
export const userRewardsStateSelector = createSelector(userStateSelector, (user) => user.rewards);
export const deleteUserRedeemRewardSelector = createSelector(userRewardsStateSelector, (rewards) => rewards.deleteUserRedeemReward);
export const deletedUserIdRedeemRewardSelector = createSelector(deleteUserRedeemRewardSelector, (deleteUserRedeemReward) => deleteUserRedeemReward.userIdRedeemDeleted);
export const deleteUserRedeemRewardErrorSelector = createSelector(deleteUserRedeemRewardSelector, (deleteUserRedeemReward) => deleteUserRedeemReward.error);
export const deleteUserRedeemRewardIsLoadingSelector = createSelector(deleteUserRedeemRewardSelector, (deleteUserRedeemReward) => deleteUserRedeemReward.isLoading);
export default {
    deletedUserIdRedeemRewardSelector,
    deleteUserRedeemRewardErrorSelector,
    deleteUserRedeemRewardIsLoadingSelector,
};
